import { Card, Typography } from "antd";

const { Text, Title } = Typography;

const StatCard = ({
  title,
  subtitle,
  trend,
  trendType = "up", // 'up' | 'down'
  icon,
  iconColor = "#000",
  tag,
}) => {
  const isUp = trendType === "up";

  const iconCircle = (
    <div
      style={{
        width: 40,
        height: 40,
        borderRadius: "50%",
        backgroundColor: iconColor,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {icon}
    </div>
  );

  return (
    <Card
      style={{
        borderRadius: 12,
        padding: 24,
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
        minHeight: 120,
      }}
    >
      <Title level={3} style={{ marginBottom: 0 }}>
        {title}
      </Title>

      {subtitle && (
        <Text style={{ fontFamily: "Poppins", fontWeight: 200 }}>
          {subtitle}
        </Text>
      )}
      <div
        style={{
          marginTop: 8,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {trend && <Text type={isUp ? "success" : "danger"}>{trend}</Text>}
        {iconCircle}
      </div>
      {tag && (
        <Text type="secondary" style={{ marginTop: 12, display: "block" }}>
          {tag}
        </Text>
      )}
    </Card>
  );
};

export default StatCard;
